export const translations = {
  sv: {
    hero: {
      title: "Investera i framtidens musik med AI",
      eyebrow: "AI-royalties · Musikbranschen · Sverige",
      subtitle: "Aifinity AB erbjuder AI-genererade musikrättigheter som skalbar, transparent intäktskälla för investerare och musikbolag.",
      cta1: "Kom igång",
      cta2: "Utforska tjänster",
      description: "Vi erbjuder moderna tjänster.",
      cta: "Kontakta oss"
    },
    navbar: {
      home: "Hem",
      services: "Tjänster",
      contact: "Kontakt",
      printing: "3D-Printning",
      artists: "Artister",
      startProject: "Starta Projekt"
    },
    artistNavbar: {
      works: "Verk",
      about: "Om",
      music: "Musik",
      contact: "Kontakt"
    },
    index: {
      about: {
        heading: "Om Aifinity",
        description: "Vi är ett innovativt tech-företag som specialiserar sig på AI-utveckling och 3D-produktion. Med vår expertis hjälper vi företag att omvandla sina visioner till verklighet genom banbrytande teknologi och kreativa lösningar.",
        cta: "Kontakta oss"
      },
      cta: {
        heading: "Redo att starta ditt projekt?",
        description: "Låt oss diskutera hur vi kan hjälpa dig att nå dina mål med AI och 3D-teknologi.",
        contact: "Kontakta oss",
        explore: "Utforska tjänster"
      }
    },
    artistsPage: {
      hero: {
        tagline: "AI-POWERED ARTIST",
        subtitle: "The intersection of Soul and Syntax"
      }
    },
    contactPage: {
      contactFor: "Kontakta oss för",
      items: [
        "AI-konsultation och utveckling",
        "3D-printning och produktion",
        "Musikproduktion och AI-artister",
        "Teknisk rådgivning"
      ]
    },
    footer: {
      companyDescription: "Framtidens AI-lösningar, 3D-printning och musikproduktion.",
      servicesTitle: "Tjänster",
      aiConsulting: "AI-Konsultationer",
      printing: "3D-Printning",
      musicProduction: "Musikproduktion",
      linksTitle: "Länkar",
      home: "Hem",
      contact: "Kontakta oss",
      followUs: "Följ oss",
      rightsReserved: "Alla rättigheter förbehållna."
    },
    services: {
      heading: "Våra Specialområden",
      description: "Vi kombinerar avancerad teknik med kreativitet för att leverera lösningar som ligger i framkant av innovation.",
      ai: {
        title: "AI-Konsultationer",
        desc: "Skräddarsydda AI-lösningar för ditt företag inklusive utveckling av AI-agenter, webbplatser och chatbotar.",
        cta: "Läs mer"
      },
      printing: {
        title: "3D-Printning",
        desc: "Unik 3D-printningsprocess som kombinerar AI-design och avancerad CAD-teknik för fantastiska resultat.",
        cta: "Utforska"
      },
      music: {
        title: "Musikproduktion",
        desc: "Upptäck vår AI-artist AIMusicDreams och upplev framtidens musikskapande med den senaste teknologin.",
        cta: "Lyssna"
      }
    },
    about: {
      heading: "Framtidens Möjligheter Idag",
      description: "Vi kombinerar AI-teknologi med mänsklig kreativitet för att skapa innovativa lösningar som driver framtiden.",
      mission: {
        title: "Vår Mission",
        desc: "Att göra avancerad teknologi tillgänglig för alla och hjälpa företag att transformera sina visioner till verklighet."
      },
      values: {
        title: "Våra Värderingar",
        innovation: "Innovation",
        innovationDesc: "Vi strävar ständigt efter att pusha gränserna för vad som är möjligt.",
        quality: "Kvalitet",
        qualityDesc: "Vi levererar alltid förstklassiga resultat som överträffar förväntningar.",
        collaboration: "Samarbete",
        collaborationDesc: "Vi arbetar nära våra kunder för att förstå deras unika behov och utmaningar."
      }
    },
    printingpage: {
      hero: {
        heading: "3D-Printning",
        description: "Vår unika process kombinerar AI-design och avancerad CAD-teknik för att skapa innovativa och personliga 3D-printade objekt.",
        cta: "Till Webshopen (kommer snart)"
      },
      process: {
        heading: "Vår Unika Process",
        steps: [
          {
            title: "AI-Driven Design",
            desc: "Vi använder AI för att generera och optimera designen baserat på dina önskemål och funktionella krav. Detta möjliggör unika och komplexa strukturer som annars skulle vara svåra att skapa."
          },
          {
            title: "CAD-Optimering",
            desc: "Våra experter förfinar AI-genererade modeller med professionella CAD-verktyg för att säkerställa teknisk precision och printbarhet, utan att kompromissa med den kreativa visionen."
          },
          {
            title: "Materialval",
            desc: "Vi erbjuder ett brett utbud av material, från standardplast till specialmaterial som metallinfusion, trä och flexibla material, för att möta dina specifika behov."
          },
          {
            title: "Högkvalitativ Printning",
            desc: "Vi använder industriella 3D-skrivare med hög precision för att ge dig förstklassiga resultat varje gång, med noggrann kvalitetskontroll i varje steg."
          }
        ]
      },
      features: {
        heading: "Våra Tjänster",
        items: [
          {
            title: "Rapid Prototyping",
            desc: "Snabbt från idé till fysisk prototyp med vår avancerade 3D-printningsteknologi."
          },
          {
            title: "Produktion",
            desc: "Skalbar produktion av 3D-printade objekt i olika material och storlekar."
          },
          {
            title: "CAD-design",
            desc: "Professionell design och optimering av 3D-modeller för optimala printresultat."
          }
        ]
      },
      gallery: {
        heading: "Exempel på Våra Skapelser",
        items: [
          "Funktionella Korgar",
          "Specialgjorda Komponenter",
          "Dekorativa Figurer"
        ],
        cta: "Se hela galleriet"
      },
      cta: {
        heading: "Redo att Skapa Något Unikt?",
        desc: "Besök vår webshop för att utforska våra färdiga produkter eller beställ en skräddarsydd skapelse för dina specifika behov.",
        shop: "Till Webshopen (kommer snart)",
        custom: "Begär Anpassad Design"
      }
    },
    musicproduction: {
      hero: {
        heading: "AIMusicDreams",
        description: "Upptäck framtidens musik med vår AI-artist AIMusicDreams. En unik fusion av mänsklig kreativitet och artificiell intelligens.",
        spotify: "Lyssna på Spotify",
        soundcloud: "SoundCloud",
        instagram: "Instagram",
        tiktok: "TikTok",
        mail: "Kontakta via mail"
      },
      about: {
        heading: "Om AIMusicDreams",
        p1: "AIMusicDreams är en banbrytande AI-artist som skapats genom att kombinera de senaste framstegen inom artificiell intelligens med professionell musikproduktion. Resultatet är en helt ny typ av musik som utmanar gränserna för vad som är möjligt.",
        p2: "Varje låt komponeras, produceras och framförs av vår AI-teknik, vilket ger en unik ljudupplevelse som konstant utvecklas och förbättras genom maskininlärning.",
        p3: "Följ AIMusicDreams på sociala medier för att hålla dig uppdaterad om de senaste låtarna och projekten:",
        instagram: "Instagram",
        tiktok: "TikTok"
      },
      cta: {
        heading: "Utforska AIMusicDreams-universumet",
        desc: "Vill du veta mer om vår AI-artist? Upptäck senaste låtarna, framtida projekt och möjligheten att önska personligt skapade låtar.",
        more: "Mer om AIMusicDreams"
      }
    },
    aiconsulting: {
      hero: {
        heading: "AI-Konsultation & Utveckling",
        description: "Skräddarsydda AI-lösningar för ditt företag. Vi hjälper dig att implementera AI-teknologi som driver resultat och innovation.",
        cta: "Kontakta oss för konsultation"
      },
      services: {
        heading: "Våra AI-Tjänster",
        agent: {
          title: "AI-Agent Utveckling",
          desc: "Bygg intelligenta AI-agenter som automatiskt hanterar uppgifter, svarar på kundfrågor och optimerar affärsprocesser.",
          bullets: [
            "Anpassade AI-agenter för dina specifika behov",
            "Integration med befintliga system",
            "Kontinuerlig förbättring genom maskininlärning",
            "24/7 tillgänglighet och support"
          ]
        },
        web: {
          title: "AI-Driven Webbplatser",
          desc: "Skapa intelligenta webbplatser som anpassar sig till användarna och optimerar konverteringar med AI-teknologi.",
          bullets: [
            "Personanpassade användarupplevelser",
            "AI-driven innehållsgenerering",
            "Automatisk SEO-optimering",
            "Analys och förbättring i realtid"
          ]
        },
        chatbot: {
          title: "AI Chatbots",
          desc: "Utveckla avancerade chatbots som förstår kontext, lär sig av interaktioner och ger exakt kundsupport.",
          bullets: [
            "Naturlig språkbehandling (NLP)",
            "Multiplattformsupport",
            "Integration med CRM-system",
            "Anpassningsbara konversationsflöden"
          ]
        },
        saas: {
          title: "Mikro SaaS-appar",
          desc: "Utveckling av fokuserade, nischade SaaS-applikationer med AI-funktionalitet för specifika problem.",
          bullets: [
            "Snabb utveckling och lansering",
            "Fokuserad funktionalitet för specifika behov",
            "Prenumerationsbaserade affärsmodeller",
            "Skalbar arkitektur"
          ]
        },
        vibe: {
          title: "Vibe Coding",
          desc: "En unik metod för att skapa estetiskt tilltalande och känslomässigt engagerande digitala upplevelser genom att kombinera design, kod och AI.",
          bullets: [
            "Känslobaserad användarupplevelse",
            "Interaktiva och responsiva element",
            "AI-drivet innehåll som anpassas efter användaren",
            "Unik visuell identitet"
          ]
        }
      },
      process: {
        heading: "Vår Arbetsprocess",
        steps: [
          {
            title: "Analys",
            desc: "Vi analyserar dina behov, utmaningar och mål för att förstå hur AI kan skapa värde för dig."
          },
          {
            title: "Design",
            desc: "Vi skapar en anpassad AI-lösning och definierar hur den ska integreras i din verksamhet."
          },
          {
            title: "Utveckling",
            desc: "Vi bygger, tränar och testar din AI-lösning för att säkerställa optimal prestanda."
          },
          {
            title: "Implementering",
            desc: "Vi implementerar lösningen, utbildar ditt team och ger kontinuerligt stöd."
          }
        ]
      }
    },
    contact: {
      hero: {
        heading: "Kontakta Oss",
        description: "Har du frågor eller vill diskutera ett projekt? Vi hjälper dig gärna!"
      },
      form: {
        heading: "Skicka ett Meddelande"
      },
      info: {
        heading: "Kontaktinformation",
        emailTitle: "E-post",
        emailDesc: "Allmänna frågor:",
        addressTitle: "Besöksadress",
        address: "AIfinity AB\nMarmorvägen 32\n653 50 Karlstad\nSverige"
      }
    },
    contactForm: {
      name: "Namn",
      namePlaceholder: "Ditt namn",
      email: "E-post",
      emailPlaceholder: "din@email.se",
      subject: "Ämne",
      subjectPlaceholder: "Vad gäller ditt meddelande?",
      message: "Meddelande",
      messagePlaceholder: "Skriv ditt meddelande här...",
      send: "Skicka meddelande",
      sending: "Skickar...",
      successTitle: "Meddelande skickat!",
      successDesc: "Tack för ditt meddelande. Vi återkommer så snart vi kan.",
      errorTitle: "Något gick fel",
      errorDesc: "Vi kunde inte skicka ditt meddelande just nu. Försök igen senare.",
      validation: {
        name: "Namnet måste vara minst 2 tecken",
        email: "Ogiltig e-postadress",
        subject: "Ämnet måste vara minst 2 tecken",
        message: "Meddelandet måste vara minst 10 tecken"
      },
      recaptcha: "Detta formulär är skyddat av Google reCAPTCHA för att säkerställa att du inte är en robot.",
      wait: "Vänta ett ögonblick",
      waitDesc: "Sidan laddar fortfarande. Försök igen om en stund."
    }
  },
  en: {
    hero: {
      title: "Invest in the Future of Music with AI",
      eyebrow: "AI Royalties · Music Industry · Sweden",
      subtitle: "Aifinity AB offers AI-generated music rights as a scalable, transparent revenue stream for investors and music companies.",
      cta1: "Get Started",
      cta2: "Explore Services",
      description: "We offer modern services.",
      cta: "Contact us"
    },
    navbar: {
      home: "Home",
      services: "Services",
      contact: "Contact",
      printing: "3D Printing",
      artists: "Artists",
      startProject: "Start Project"
    },
    artistNavbar: {
      works: "Works",
      about: "About",
      music: "Music",
      contact: "Contact"
    },
    index: {
      about: {
        heading: "About Aifinity",
        description: "We are an innovative tech company specializing in AI development and 3D production. With our expertise, we help businesses transform their visions into reality through groundbreaking technology and creative solutions.",
        cta: "Contact us"
      },
      cta: {
        heading: "Ready to start your project?",
        description: "Let's discuss how we can help you achieve your goals with AI and 3D technology.",
        contact: "Contact us",
        explore: "Explore services"
      }
    },
    artistsPage: {
      hero: {
        tagline: "AI-POWERED ARTIST",
        subtitle: "The intersection of Soul and Syntax"
      }
    },
    contactPage: {
      contactFor: "Contact us for",
      items: [
        "AI consultation and development",
        "3D printing and production",
        "Music production and AI artists",
        "Technical consulting"
      ]
    },
    footer: {
      companyDescription: "Future AI solutions, 3D printing and music production.",
      servicesTitle: "Services",
      aiConsulting: "AI Consultations",
      printing: "3D Printing",
      musicProduction: "Music Production",
      linksTitle: "Links",
      home: "Home",
      contact: "Contact us",
      followUs: "Follow us",
      rightsReserved: "All rights reserved."
    },
    services: {
      heading: "Our Specializations",
      description: "We combine advanced technology with creativity to deliver solutions at the forefront of innovation.",
      ai: {
        title: "AI Consultations",
        desc: "Tailored AI solutions for your business including AI agent development, websites and chatbots.",
        cta: "Learn more"
      },
      printing: {
        title: "3D Printing",
        desc: "Unique 3D printing process combining AI design and advanced CAD technology for amazing results.",
        cta: "Explore"
      },
      music: {
        title: "Music Production",
        desc: "Discover our AI artist AIMusicDreams and experience the future of music creation with the latest technology.",
        cta: "Listen"
      }
    },
    about: {
      heading: "Future Possibilities Today",
      description: "We combine AI technology with human creativity to create innovative solutions that drive the future.",
      mission: {
        title: "Our Mission",
        desc: "To make advanced technology accessible to everyone and help companies transform their visions into reality."
      },
      values: {
        title: "Our Values",
        innovation: "Innovation",
        innovationDesc: "We constantly strive to push the boundaries of what's possible.",
        quality: "Quality",
        qualityDesc: "We always deliver first-class results that exceed expectations.",
        collaboration: "Collaboration",
        collaborationDesc: "We work closely with our customers to understand their unique needs and challenges."
      }
    },
    aiconsulting: {
      hero: {
        heading: "AI Consulting & Development",
        description: "Tailored AI solutions for your business. We help you implement AI technology that drives results and innovation.",
        cta: "Contact us for consultation"
      },
      services: {
        heading: "Our AI Services",
        agent: {
          title: "AI Agent Development",
          desc: "Build intelligent AI agents that automatically handle tasks, answer customer questions and optimize business processes.",
          bullets: [
            "Custom AI agents for your specific needs",
            "Integration with existing systems",
            "Continuous improvement through machine learning",
            "24/7 availability and support"
          ]
        },
        web: {
          title: "AI-Driven Websites",
          desc: "Create intelligent websites that adapt to users and optimize conversions with AI technology.",
          bullets: [
            "Personalized user experiences",
            "AI-driven content generation",
            "Automatic SEO optimization",
            "Real-time analytics and improvement"
          ]
        },
        chatbot: {
          title: "AI Chatbots",
          desc: "Develop advanced chatbots that understand context, learn from interactions and provide accurate customer support.",
          bullets: [
            "Natural language processing (NLP)",
            "Multi-platform support",
            "CRM system integration",
            "Customizable conversation flows"
          ]
        },
        saas: {
          title: "Micro SaaS Apps",
          desc: "Development of focused, niche SaaS applications with AI functionality for specific problems.",
          bullets: [
            "Fast development and launch",
            "Focused functionality for specific needs",
            "Subscription-based business models",
            "Scalable architecture"
          ]
        },
        vibe: {
          title: "Vibe Coding",
          desc: "A unique method for creating aesthetically pleasing and emotionally engaging digital experiences by combining design, code, and AI.",
          bullets: [
            "Emotion-based user experience",
            "Interactive and responsive elements",
            "AI-driven content that adapts to the user",
            "Unique visual identity"
          ]
        }
      },
      process: {
        heading: "Our Work Process",
        steps: [
          {
            title: "Analysis",
            desc: "We analyze your needs, challenges, and goals to understand how AI can create value for you."
          },
          {
            title: "Design",
            desc: "We create a customized AI solution and define how it will be integrated into your business."
          },
          {
            title: "Development",
            desc: "We build, train, and test your AI solution to ensure optimal performance."
          },
          {
            title: "Implementation",
            desc: "We implement the solution, train your team, and provide continuous support."
          }
        ]
      }
    },
    printingpage: {
      hero: {
        heading: "3D Printing",
        description: "Our unique process combines AI design and advanced CAD technology to create innovative and personalized 3D printed objects.",
        cta: "To Webshop (coming soon)"
      },
      process: {
        heading: "Our Unique Process",
        steps: [
          {
            title: "AI-Driven Design",
            desc: "We use AI to generate and optimize the design based on your requirements and functional needs. This enables unique and complex structures that would otherwise be difficult to create."
          },
          {
            title: "CAD Optimization",
            desc: "Our experts refine AI-generated models with professional CAD tools to ensure technical precision and printability, without compromising the creative vision."
          },
          {
            title: "Material Selection",
            desc: "We offer a wide range of materials, from standard plastic to specialty materials such as metal infusion, wood and flexible materials, to meet your specific needs."
          },
          {
            title: "High Quality Printing",
            desc: "We use industrial 3D printers with high precision to give you first-class results every time, with careful quality control at every step."
          }
        ]
      },
      features: {
        heading: "Our Services",
        items: [
          {
            title: "Rapid Prototyping",
            desc: "Quickly from idea to physical prototype with our advanced 3D printing technology."
          },
          {
            title: "Production",
            desc: "Scalable production of 3D printed objects in various materials and sizes."
          },
          {
            title: "CAD Design",
            desc: "Professional design and optimization of 3D models for optimal print results."
          }
        ]
      },
      gallery: {
        heading: "Examples of Our Creations",
        items: [
          "Functional Baskets",
          "Custom Components",
          "Decorative Figures"
        ],
        cta: "See full gallery"
      },
      cta: {
        heading: "Ready to Create Something Unique?",
        desc: "Visit our webshop to explore our finished products or order a custom creation for your specific needs.",
        shop: "To Webshop (coming soon)",
        custom: "Request Custom Design"
      }
    },
    musicproduction: {
      hero: {
        heading: "AIMusicDreams",
        description: "Discover the future of music with our AI artist AIMusicDreams. A unique fusion of human creativity and artificial intelligence.",
        spotify: "Listen on Spotify",
        soundcloud: "SoundCloud",
        instagram: "Instagram",
        tiktok: "TikTok",
        mail: "Contact via mail"
      },
      about: {
        heading: "About AIMusicDreams",
        p1: "AIMusicDreams is a groundbreaking AI artist created by combining the latest advances in artificial intelligence with professional music production. The result is a completely new type of music that challenges the boundaries of what's possible.",
        p2: "Each song is composed, produced and performed by our AI technology, providing a unique sound experience that constantly evolves and improves through machine learning.",
        p3: "Follow AIMusicDreams on social media to stay updated on the latest songs and projects:",
        instagram: "Instagram",
        tiktok: "TikTok"
      },
      cta: {
        heading: "Explore the AIMusicDreams Universe",
        desc: "Want to know more about our AI artist? Discover the latest songs, future projects and the opportunity to request personally created songs.",
        more: "More about AIMusicDreams"
      }
    },
    contact: {
      hero: {
        heading: "Contact Us",
        description: "Do you have questions or want to discuss a project? We'd love to help!"
      },
      form: {
        heading: "Send a Message"
      },
      info: {
        heading: "Contact Information",
        emailTitle: "Email",
        emailDesc: "General questions:",
        addressTitle: "Visit Address",
        address: "AIfinity AB\nMarmorvägen 32\n653 50 Karlstad\nSweden"
      }
    },
    contactForm: {
      name: "Name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "your@email.com",
      subject: "Subject",
      subjectPlaceholder: "What is your message about?",
      message: "Message",
      messagePlaceholder: "Write your message here...",
      send: "Send message",
      sending: "Sending...",
      successTitle: "Message sent!",
      successDesc: "Thank you for your message. We will get back to you as soon as we can.",
      errorTitle: "Something went wrong",
      errorDesc: "We couldn't send your message right now. Please try again later.",
      validation: {
        name: "Name must be at least 2 characters",
        email: "Invalid email address",
        subject: "Subject must be at least 2 characters",
        message: "Message must be at least 10 characters"
      },
      recaptcha: "This form is protected by Google reCAPTCHA to ensure you are not a robot.",
      wait: "Wait a moment",
      waitDesc: "The page is still loading. Please try again in a moment."
    }
  }
};